
<div>
    <d-recipients-edit
        v-model       = "create"
        :recipient-id = "-1"
        :customer-id  = "customerId"
        @saved        = "onCreated"
    />
    <c-card-iterator
        :label         = "title"
        v-if           = "items"
        :items         = "items"
        :filter-height = "150"
        :item-height   = "190"
        :min-height    = "topSpace"
        :height        = "height"
        :filter        = "itemFilter"
        :enable-search = "false"
        :zoom          = "enableZoom"
        :left-arrow    = "leftArrow"
        :header-color  = "headerColor"
        class          = "w-100"
        @zoom          = "onZoom"
        @remove-filter = "onRemoveFilter"
    >
        <template v-slot:toolbar>
            <div class="pl-1" style="margin-top: -2px">
                <c-toolbar-button
                    :size    = "24"
                    icon     = "mdi-plus"
                    color    = "white"
                    :tooltip = "$t('msd.recipient.create')"
                    @click   = "onCreate"
                />
            </div>
        </template>
        <template v-slot:filter>
            <c-recipient-card-filter
                :filter          = "filter"
                :color           = "headerColor"
                @changed         = "onFilter"
            />
        </template>
        <template v-slot:card="{ item }">
            <c-recipient-card
                @selected        = "onSelected"
                @edit            = "onEditRecipient"
                @saved           = "onSaved"
                style            = "width: calc(100% - 1px)"
                :highlight-color = "color(item)"
                :company         = "item"
                :background      = "selected && selected.id === item.id ? 'card-preselected' : null"
            />
        </template>
    </c-card-iterator>
</div>
